export interface JobStatus {
  PartitionKey: string;
  RowKey: string;
  ClientId: string;
  BatchId: string;
  JobStatus: string;
  FileStatus: string;
  FileName: string;
}

export enum CurrentProcess {
  ExtractionStarted = 0,
  ExtractionCompleted = 1,
  MergeActivityComplete = 2,
  DataSyncCompleted = 3,

  ExtractionFailed = 1 + 20,
  MergeActivityFailed = 2 + 20,
  DataSyncFailed = 3 + 20,

  Completed = 100,
  Failed = 50,
}

export enum FileExtractionStatus {
  ExtractionStarted = 0,
  DocumentIntelligence = 1,
  ExtractionCompleted = 2,

  DocumentIntelligenceFailure = 1 + 20,
  ExtractionFailure = 2 + 20,
}

export interface FileStatus {
  FileName: string;
  Status: FileExtractionStatus;
}

export const stringToCurrentProcess = (str: string) => {
  return CurrentProcess[str as keyof typeof CurrentProcess];
};

export const stringToFileExtractionStatus = (str: string) => {
  return FileExtractionStatus[str as keyof typeof FileExtractionStatus];
};
